import { render } from "./FooterBody.vue?vue&type=template&id=7521c2b2"
import script from "./FooterBody.vue?vue&type=script&lang=js"
export * from "./FooterBody.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__